import {createContext, useContext, useEffect, useState} from 'react';
import axios from 'axios'
import {EnvContext} from './EnvContext';
import { UserContext } from './UserContext';

export const InventoryContext = createContext();

export const InventoryContextProvider = ({children}) => {

    const baseURL = window.location.host == "localhost:3000" || "dashboard.wholesalechad.com" ? "https://dashboard.wholesalechad.com/" : "https://dashboard.wholesalechad.com/";

    const Axios = axios.create({ baseURL: baseURL });

    const [inventoryImages,setInventoryImages] = useState([]);

    const getInventoryImages = async (show_published) => {
        try {

            const values = {'action':'get_images','show_published':show_published};
            console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/inventory/inventory_images.php',values);

            console.log(response.data);
            setInventoryImages(response.data);


        } catch (error) {
            console.error('Error getting inventory images:', error);
            return {}; //Or handle error as needed
        }
    };

    const uploadDocument = async (values) => {

        console.log(values);

        const {data} = await Axios.post('bridge/inventory/s3_upload_file.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
        });

        console.log(data);

        return data;
    }

    const addInventoryImage = async (vin,image) => {
        try {

            const values = {'action':'insert_image','vin':vin,'image':image};
            console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/inventory/inventory_images.php',values);

            console.log(response.data);

            return response.data;
        } catch (error) {
            console.error('Error getting leaderboard:', error);
            return {}; //Or handle error as needed
        }
    };

    const publishVehicle = async (vin,scraped_images='') => {
        try {

            const values = {'action':'publish_vehicle','vin':vin,'scraped_images':scraped_images};
            console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/inventory/inventory_images.php',values);

            console.log(response.data);

            return response.data;
        } catch (error) {
            console.error('Error getting leaderboard:', error);
            return {}; //Or handle error as needed
        }
    };

    const deleteInventoryImages = async (vin) => {
        try {

            const values = {'action':'delete_images','vin':vin};
            console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/inventory/inventory_images.php',values);

            console.log(response.data);

            return response.data;
        } catch (error) {
            console.error('Error getting leaderboard:', error);
            return {}; //Or handle error as needed
        }
    };

    return (
        <>
            <InventoryContext.Provider value={{getInventoryImages, inventoryImages, uploadDocument, addInventoryImage, deleteInventoryImages, publishVehicle}}>
                {children}
            </InventoryContext.Provider>
        </>
    );
}

export default InventoryContextProvider